import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import {
  ImageContainer,
  ImageSectionContainer,
  RedeemBlockContainer, RedeemRewardDescription, RedeemRewardTextContainer,
  RedeemRewardTitle
} from './RedeemRewardBlockStyle';
import PictureImage from '../../utils/Image/PictureImage';
import { getImage } from '../../utils/Functions';
import Fade from "react-reveal/Fade";

interface IRedeemRewardBlock {
  context? :IContent;
}

const DESKTOP_IMAGE = 'redeem_reward_images';

const RedeemRewardBlock = ({context} : IRedeemRewardBlock) => {
  return (
    <RedeemBlockContainer>
      <RedeemRewardTextContainer>
        <Fade left distance={"2%"}>
          <RedeemRewardTitle dangerouslySetInnerHTML={{ __html: context.redeem.title }}/>
          <RedeemRewardDescription isMobileTitle={false} >{context.redeem.description}</RedeemRewardDescription>
        </Fade>
      </RedeemRewardTextContainer>
      <ImageSectionContainer >
        <Fade center delay={300}>
        <ImageContainer>
            <PictureImage
              images={getImage(DESKTOP_IMAGE, true)}
              extension="png"
              altText={DESKTOP_IMAGE}
              className={[""]}
            />
        </ImageContainer>
        </Fade>
      </ImageSectionContainer>
      <RedeemRewardDescription isMobileTitle={true} >{context.redeem.description}</RedeemRewardDescription>
    </RedeemBlockContainer>
  );
};

export default withContent(RedeemRewardBlock);